import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Body, Button } from '@walmart-web/livingdesign-components';
import { useTranslation } from 'react-i18next';
import AlertDialog from 'components/AlertDialog';
import { useCommonOAuthRedirect } from '../../../../hooks/useCommonOAuthRedirect';
import { isMaverickFlow } from '../../../../utils/authFlowUtils';

const JobPreferenceAlert = (props) => {
	const { t } = useTranslation();
	const { isNoJobPreference } = useSelector((state) => state?.renew);

	const {handleContinueRedirect} = useCommonOAuthRedirect({type:"CP_RENEW",status:"SUCCESS",autoRedirect:false});

	const postRenewActions = () => {
		return (
			<div>
				<Button
					onClick={props.handleNo}
					size="medium"
					variant="tertiary"
					UNSAFE_style={{ padding: '0 32px' }}>
					{t('general.no')}
				</Button>
				<Button onClick={props.handleYes} size="medium" variant="primary">
					{t('general.yes')}
				</Button>
			</div>
		);
	};

	useEffect(() => {
		if (props.renewCompleted && isMaverickFlow()) {
			handleContinueRedirect();
		}
	}, [props.renewCompleted, handleContinueRedirect]);


	return isMaverickFlow() ? (<></>) : (
		<div>
			<AlertDialog
				isOpen={props.renewCompleted}
				onClose={() => props.handleClose()}
				title={t('renew.successRenew')}
				actions={postRenewActions()}>
				<Body as="div" size="medium" weight={400}>
					{isNoJobPreference ? t('renew.noJobPref') : t('renew.dialogTitleRenew')}
				</Body>
			</AlertDialog>
		</div>
	);
};

export default JobPreferenceAlert;
